import React from "react";
import BlogImage from "../../components/Blog Details/BlogImage";
import BlogImageHeading from "../../components/Blog Details/BlogImageHeading";
import BodyContent from "../../components/Blog Details/BodyContent";
import PageHeader from "../../components/common/PageHeader";

const BlogDetails = () => {
  return (
    <div>
      <PageHeader pageName={"Blog Details"} />
      <BlogImage />
      <BlogImageHeading />
      <BodyContent />
    </div>
  );
};

export default BlogDetails;
